export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M32 3 57 17.5v29L32 61 7 46.5v-29Z" fill="#0B0E1B" stroke="#A78BFA" strokeWidth="3" strokeLinejoin="round" />
    <path d="M18 20 25 14 28 22Z M46 20 39 14 36 22Z" fill="#FF2E4D" />
    <path d="M19 24 32 48 45 24" fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M24 33h16M27.5 40h9" stroke="#38BDF8" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = () => (
  <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-2.5 group">
    <LogoMark className="w-9 h-9 transition-transform duration-500 group-hover:rotate-[30deg]" />
    <span className="font-display text-[15px] leading-none tracking-tight text-white">
      VINSLAB<span className="block text-[10px] font-mono tracking-[0.3em] text-sky-300 mt-1">MAKER</span>
    </span>
  </a>
);
